module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "voiture_face.61709c2f.svg";